import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import {
  SaveTestAccuracyResultSchema,
  StartTestAccuracyTestBodySchema,
  StartTestAccuracyTestResponseSchema,
  TestAccuracyQuestionsQuerySchema,
  TestAccuracyQuestionsResponseSchema,
  TestAccuracyResultsResponseSchema,
} from '@conversed/shared/src/central/types/test-accuracy';
import z from 'zod';
import { createRESTContract } from '../../index';

export const testAccuracyContract = createRESTContract({
  getTestAccuracyQuestions: {
    method: 'GET',
    path: '/test-accuracy/questions',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: TestAccuracyQuestionsResponseSchema,
    query: TestAccuracyQuestionsQuerySchema,
  },
  startTestAccuracyTest: {
    method: 'POST',
    path: '/test-accuracy/start-test',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: StartTestAccuracyTestResponseSchema,
    body: StartTestAccuracyTestBodySchema,
  },
  saveTestAccuracyResult: {
    method: 'POST',
    path: '/test-accuracy/save-result',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: z.void(),
    body: SaveTestAccuracyResultSchema,
  },
  toggleTestAccuracyVisibility: {
    method: 'POST',
    path: '/test-accuracy/toggle-visibility',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    body: z.object({
      id: z.string(),
      isVisible: z.boolean(),
    }),
    response: z.void(),
  },
  getTestAccuracyResults: {
    method: 'GET',
    path: '/test-accuracy/results',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: TestAccuracyResultsResponseSchema,
  },
  deleteTestAccuracyResult: {
    method: 'DELETE',
    path: '/test-accuracy/:id',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: z.void(),
    body: z.undefined(),
  },
});
